import { Component, OnInit, ElementRef, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatbotService } from './data-access/services/chatbot.service';
import { Message } from './data-access/models/chatbot.model';

@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css']
})
export class ChatbotComponent implements OnInit {
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;

  private chatbotService = inject(ChatbotService);
  
  messages: Message[] = [];
  userInput: string = '';
  isTyping: boolean = false;
  conversationId?: string;

  ngOnInit(): void {
    // Mensaje de bienvenida
    this.addBotMessage('¡Hola! Soy tu asistente virtual. ¿En qué puedo ayudarte hoy?');
  }

  sendMessage(): void {
    if (this.userInput.trim() === '') return;

    // Agregar mensaje del usuario
    this.messages.push({
      text: this.userInput,
      isUser: true,
      timestamp: new Date()
    });

    const userMessage = this.userInput;
    this.userInput = '';
    
    // Mostrar indicador de escritura
    this.isTyping = true;
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);

    // Enviar pregunta al servicio del chatbot
    this.chatbotService.sendQuestion(userMessage, this.conversationId).subscribe({
      next: (response) => {
        this.isTyping = false;
        this.conversationId = response.conversationId;
        this.addBotMessage(response.message);
      },
      error: (error) => {
        this.isTyping = false;
        console.error('Error al obtener respuesta del chatbot:', error);
        this.addBotMessage('Lo siento, ha ocurrido un error. Por favor, intenta de nuevo.');
      }
    });
  }

  private addBotMessage(text: string): void {
    this.messages.push({
      text,
      isUser: false,
      timestamp: new Date()
    });
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  private scrollToBottom(): void {
    try {
      if (this.messagesContainer) {
        this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
      }
    } catch(err) {
      console.error('Error al hacer scroll:', err);
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }
}
